import React, { useState } from 'react';
import '../ReviewsKlantenPage/Styles.css';

const TestimonialSection = () => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    const testimonials = [
        {
            text: "Agija was mijn eerste yogadocent, en zij heeft bij mij een blijvende liefde voor yoga aangewakkerd. Ze weet perfect de balans te vinden tussen rust en sportiviteit, zonder dat het te spiritueel wordt. Haar lessen zijn goed om te volgen voor beginners, omdat ze altijd verschillende opties aanbiedt voor elk niveau.",
            name: "Davinia",
            rating: 5
        },
        {
            text: "Jong of oud, elk lichaamstype is welkom - Agija past elke oefening aan ieders kunnen. Niemand moet zich ongemakkelijk voelen en iedereen krijgt voldoende uitdaging. Ze geeft ook aan wat en waar je moet voelen bij een bepaalde beweging, wat ook heel fijn is. Haar lessen brengen rust in het hoofd en lichaam, en voelen tegelijk als een workout - helemaal niet zweverig.",
            name: "Jennifer",
            rating: 4.5
        }
    ];

    const nextTestimonial = () => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setCurrentTestimonial((prev) =>
            prev === 0 ? testimonials.length - 1 : prev - 1
        );
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, index) => {
            const starNumber = index + 1;

            if (rating >= starNumber) {
                return (
                    <span key={index} className="star full">
                        ★
                    </span>
                );
            } else if (rating >= starNumber - 0.5) {
                return (
                    <span key={index} className="star half">
                        ★
                    </span>
                );
            } else {
                return (
                    <span key={index} className="star empty">
                        ★
                    </span>
                );
            }
        });
    };

    return (
        <div className='testimonialSection'>
            <img 
                src='/images/MindfulBreaks_Logo_CMYK_brandmark_White.png' 
                alt='decoratief icoon'
                className='testimonialIcon'
            />

            <h1 className='testimonialTitle'>Ervaringen van klanten</h1>

            <p className='testimonialSubtitle'>
                Lees hoe anderen opnieuw rust, balans en vertrouwen in hun lichaam vonden.
            </p>

            <div className='testimonialSlider'>
                <div className='testimonialStars'>
                    {renderStars(testimonials[currentTestimonial].rating)}
                </div>

                <p className='testimonialText'>
                    "{testimonials[currentTestimonial].text}"
                </p>

                <div className='testimonialFooter'>
                    <div className='testimonialDivider'></div>

                    <h3 className='testimonialName'>
                        {testimonials[currentTestimonial].name}
                    </h3>

                    <span className='testimonialRole'>Klant</span>
                </div>

                <div className='testimonialButtons'>
                    <button onClick={prevTestimonial}>←</button>
                    <button onClick={nextTestimonial}>→</button>
                </div>
            </div>
        </div>
    );
};

export default TestimonialSection;